import React from "react";
import Product from "../components/Product";

const Shpop = () => {
  return (
    <div>
      <Product />
    </div>
  );
};

export default Shpop;
